import { Locale, View } from 'ckeditor5';
import { createRoot } from "react-dom/client";
import FileManagerElement from './FileManagerElement';
import ArquivoConteudo from "@/Models/Domain/Servico/ArquivoConteudo";
export default class FileManagerView extends View {
	private _onChange:(arquivo:ArquivoConteudo) => void;
	constructor({
		locale,
		onChange
	}:{
		locale: Locale,
		onChange:(arquivo:ArquivoConteudo) => void;
	}) {
		super(locale);

		this._onChange = onChange;
		
		this.setTemplate( {
			tag: 'div',
			attributes: {
				class: [ 'ck', 'ck-abbr-form' ],
				tabindex: '-1'
			}
		} );
	}
	render() {
		super.render();

		const root = createRoot(this.element!);

		root.render(<FileManagerElement onChange={this._onChange} />);
	}
	destroy() {
		const root = createRoot(this.element!);
		root.unmount(); 
		super.destroy();
	}
	focus() {
		//this.childViews.first.focus();
	}
}